<script>
export default {
  name: 'NewYearTimer',
  data () {
    return {
      targetDate: new Date('2026-01-01T00:00:00'),
      timeLeft: {
        day: '00',
        hour: '00',
        minutes: '00',
        seconds: '00'
      },
      interval: null
    }
  },
  methods: {
    updateTime () {
      const now = new Date()
      const diff = this.targetDate - now

      if (diff <= 0) {
        this.timeLeft = {
          day: '00',
          hour: '00',
          minutes: '00',
          seconds: '00'
        }
        return
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24)
      const minutes = Math.floor((diff / (1000 * 60)) % 60)
      const seconds = Math.floor((diff / 1000) % 60)

      this.timeLeft = {
        day: String(days).padStart(2, '0'),
        hour: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0')
      }
    }
  },
  mounted () {
    this.updateTime()
    this.interval = setInterval(this.updateTime, 1000)
  },
  beforeUnmount () {
    clearInterval(this.interval)
  }
}
</script>

<template>
  <div class="new-year-timer">
    <span class="timer-item">{{timeLeft.day}}</span>
    <span class="timer-item">{{timeLeft.hour}}</span>
    <span class="timer-item">{{timeLeft.minutes}}</span>
    <span class="timer-item">{{timeLeft.seconds}}</span>
  </div>
</template>

<style scoped lang="scss">
.new-year-timer {
  margin-top: 8px;
  .timer-prepend {
    font-size: 1.2rem;
  }
  .timer-item {
    margin: 0 4px;
    text-align: center;
    display: inline-block;
    min-width: 50px;
    font-size: 2rem;
    border-radius: 12px;
    color: #fff;

    // градиентный фон с анимацией
    background: linear-gradient(270deg, rgba(0, 196, 255, 0.89), rgba(49, 138, 198, 0.16), rgba(20, 139, 213, 0.09), rgba(38, 159, 195, 0.58));
    background-size: 600% 600%;
    animation: gradientFlow 30s ease infinite;

    // лёгкое свечение
   // box-shadow: 0 0 12px rgba(0, 196, 255, 0.6);
  }
}

// анимация движения градиента
@keyframes gradientFlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
